// import React, { useEffect, useState } from "react";
// import "tailwindcss/tailwind.css";
// import { Edit, File, Ban } from "tabler-icons-react";
// import { Table, ActionIcon } from "@mantine/core";
// import { getInvoiceDataAPI } from "../../utilities/apis/recovery";
// import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
// import { formatDate, formatNumberWithCommas } from "../../utilities/utilities";
// import { getReadPresignedUrl } from "../../utilities/apis/commonApis";
// import { disableInvoice } from "../../utilities/apis/recovery";

// function InvoiceListSection({ dueDetailId, invoiceData = {}, setInvoiceData = {}, setDueDetail = {} }) {
//     const [invList, setInvList] = useState([]);
//     const fetchInvoices = async () => {

//         const response = await apiWrapWithErrorWithData(
//             getInvoiceDataAPI({ dueDetailId })
//         );
//         if (response.success) {
//             console.log(response.data);
//             setInvList(response.data);
//         }
//     };
//     const handleFileOpening = async (row) => {
//         const response = await apiWrapWithErrorWithData(
//             getReadPresignedUrl({
//                 hostedLink: row.invoiceCopyUrl,
//                 parentId: row.id,
//                 parent: "invoiceData",
//             })
//         );
//         if (response?.success && response?.signedUrl) {
//             window.open(response.signedUrl, "_blank").focus();
//         }
//     };
//     const handleInvoiceEdit = (row) => {
//         setInvoiceData((prevState) => ({
//             ...prevState,
//             isModalOpen: true,
//             isEdit: true,
//             id: row.id,
//             number: row.invoiceNumber,
//             date: new Date(row.dueDate),
//             amount: row.invoiceAmount,
//             currencyType: row.currencyType,
//             creditPeriod: row.creditPeriod,
//             penaltyRate: row.penaltyRate,
//             files: "",
//         }));
//     };
//     const handleInvoiceDisable = async (row) => {
//         const response = await apiWrapWithErrorWithData(
//             disableInvoice({
//                 id: row.id,
//                 dueDetailId
//             })
//         );
//         if (response.success) {
//             fetchInvoices();
//             setDueDetail((prevState) => ({
//                 ...prevState,
//                 recoveryAmount: response.data.recoveryAmount,
//                 currencyType: response.data.currencyType,
//                 noOfInvoice: response.data.noOfInvoice,
//                 firstInvDate: response.data.firstInvDate,
//             }));
//         }
//     }
//     const getAgeingDays = (dueDate, creditPeriod) => {
//         const dueDateObj = new Date(dueDate);
//         dueDateObj.setDate(dueDateObj.getDate() + creditPeriod);
//         dueDateObj.setUTCHours(0, 0, 0, 0);
//         const currentDate = new Date();
//         currentDate.setUTCHours(0, 0, 0, 0);
//         const diffTime = Math.abs(currentDate - dueDateObj);
//         const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//         return diffDays;
//     };

//     useEffect(() => {
//         fetchInvoices();
//     }, [invoiceData.isModalOpen]);

//     return (
//         <>
//             {invList.length > 0 && (
//                 <Table striped highlightOnHover={true} className={Object.keys(invoiceData).length !== 0 ? "mt-10" : "mt-5"}>
//                     <thead>
//                         <tr>
//                             <th>invoice number</th>
//                             <th>invoice date</th>
//                             <th>amount</th>
//                             <th>currency type</th>
//                             <th>penalty rate per annum</th>
//                             <th>credit period</th>
//                             <th>ageing</th>
//                             <th>&nbsp;</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {invList.map((invoice) => (
//                             <tr key={invoice.id}>
//                                 <td>{invoice.invoiceNumber}</td>
//                                 <td>{formatDate(invoice.dueDate)}</td>
//                                 <td className="text-right">{formatNumberWithCommas(invoice.invoiceAmount)}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
//                                 <td>{invoice.currencyType}</td>
//                                 <td className="text-right">{`${invoice.penaltyRate}%`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
//                                 <td>{`${invoice.creditPeriod} days`}</td>
//                                 <td>{`${getAgeingDays(invoice.dueDate, invoice.creditPeriod)} days`}</td>
//                                 <td>
//                                     <div className="grid grid-cols-2">
//                                         <ActionIcon
//                                             title="Open"
//                                             onClick={() => handleFileOpening(invoice)}
//                                         >
//                                             <File />
//                                         </ActionIcon>
//                                         {Object.keys(invoiceData).length !== 0 && (
//                                             <ActionIcon
//                                                 title="Disable"
//                                                 onClick={() => handleInvoiceDisable(invoice)}
//                                             >
//                                                 <Ban color="red" />
//                                             </ActionIcon>
//                                         )}
//                                         {/* <ActionIcon
//                                             title="Edit"
//                                             onClick={() => handleInvoiceEdit(invoice)}
//                                         >
//                                             <Edit color="red" />
//                                         </ActionIcon> */}
//                                     </div>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </Table>
//             )}
//         </>
//     );
// }

// export default InvoiceListSection;

import React, { useEffect, useState } from "react";
import "tailwindcss/tailwind.css";
import { Edit, File, Ban } from "tabler-icons-react";
import { Table, ActionIcon, Text } from "@mantine/core";
import { getInvoiceDataAPI } from "../../utilities/apis/recovery";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { formatDate, formatNumberWithCommas } from "../../utilities/utilities";
import { getReadPresignedUrl } from "../../utilities/apis/commonApis";
import { disableInvoice } from "../../utilities/apis/recovery";

function InvoiceListSection({ dueDetailId, invoiceData = {}, setInvoiceData = {}, setDueDetail = {} }) {
    const [invList, setInvList] = useState([]);
    const fetchInvoices = async () => {

        const response = await apiWrapWithErrorWithData(
            getInvoiceDataAPI({ dueDetailId })
        );
        if (response.success) {
            console.log(response.data);
            setInvList(response.data);
        }
    };
    const handleFileOpening = async (row) => {
        const response = await apiWrapWithErrorWithData(
            getReadPresignedUrl({
                hostedLink: row.invoiceCopyUrl,
                parentId: row.id,
                parent: "invoiceData",
            })
        );
        if (response?.success && response?.signedUrl) {
            window.open(response.signedUrl, "_blank").focus();
        }
    };
    const handleInvoiceEdit = (row) => {
        setInvoiceData((prevState) => ({
            ...prevState,
            isModalOpen: true,
            isEdit: true,
            id: row.id,
            number: row.invoiceNumber,
            date: new Date(row.dueDate),
            amount: row.invoiceAmount,
            currencyType: row.currencyType,
            creditPeriod: row.creditPeriod,
            penaltyRate: row.penaltyRate,
            files: "",
        }));
    };
    const handleInvoiceDisable = async (row) => {
        const response = await apiWrapWithErrorWithData(
            disableInvoice({
                id: row.id,
                dueDetailId
            })
        );
        if (response.success) {
            fetchInvoices();
            setDueDetail((prevState) => ({
                ...prevState,
                recoveryAmount: response.data.recoveryAmount,
                currencyType: response.data.currencyType,
                noOfInvoice: response.data.noOfInvoice,
                firstInvDate: response.data.firstInvDate,
            }));
        }
    };
    const getAgeingDays = (dueDate, creditPeriod) => {
        const dueDateObj = new Date(dueDate);
        dueDateObj.setDate(dueDateObj.getDate() + creditPeriod);
        dueDateObj.setUTCHours(0, 0, 0, 0);
        const currentDate = new Date();
        currentDate.setUTCHours(0, 0, 0, 0);
        const diffTime = Math.abs(currentDate - dueDateObj);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    };

    useEffect(() => {
        fetchInvoices();
    }, [invoiceData.isModalOpen]);

    // Header styling definition matching the template
    const headerStyle = (align = 'left') => ({
        color: '#64748b', // Slate 500
        fontSize: '12px', 
        fontWeight: 600, 
        textTransform: 'uppercase', 
        letterSpacing: '0.05em',
        textAlign: align,
        paddingTop: '16px',
        paddingBottom: '16px',
        borderBottom: '1px solid #e2e8f0'
    });

    // Body cell styling definition matching the template
    const cellStyle = (align = 'left') => ({
        textAlign: align,
        paddingTop: '14px',
        paddingBottom: '14px'
    });

    return (
        <>
            {invList.length > 0 && (
                <div className={`${Object.keys(invoiceData).length !== 0 ? "mt-10" : "mt-5"} overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm ring-1 ring-black ring-opacity-5`}>
                    <div className="overflow-x-auto">
                        <Table 
                            verticalSpacing="sm" 
                            horizontalSpacing="lg" 
                            highlightOnHover={true} 
                            className="min-w-full divide-y divide-slate-200"
                        >
                            <thead className="bg-slate-50/80 backdrop-blur-sm sticky top-0 z-10">
                                <tr>
                                    <th style={headerStyle('left')}>invoice number</th>
                                    <th style={headerStyle('left')}>invoice date</th>
                                    <th style={headerStyle('right')}>amount</th>
                                    <th style={headerStyle('left')}>currency type</th>
                                    <th style={headerStyle('right')}>penalty rate per annum</th>
                                    <th style={headerStyle('left')}>credit period</th>
                                    <th style={headerStyle('left')}>ageing</th>
                                    <th style={headerStyle('center')}>Action</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100 bg-white">
                                {invList.map((invoice) => (
                                    <tr 
                                        key={invoice.id}
                                        className="group transition-all duration-200 hover:bg-blue-50/30"
                                    >
                                        <td style={cellStyle('left')} className="whitespace-nowrap">
                                            <Text size="sm" weight={500} className="text-slate-700">
                                                {invoice.invoiceNumber}
                                            </Text>
                                        </td>
                                        <td style={cellStyle('left')} className="whitespace-nowrap">
                                            <Text size="sm" weight={500} className="text-slate-700">
                                                {formatDate(invoice.dueDate)}
                                            </Text>
                                        </td>
                                        <td style={cellStyle('right')} className="whitespace-nowrap">
                                            <Text size="sm" weight={500} className="text-slate-700">
                                                {formatNumberWithCommas(invoice.invoiceAmount)}
                                            </Text>
                                        </td>
                                        <td style={cellStyle('left')} className="whitespace-nowrap">
                                            <Text size="sm" weight={500} className="text-slate-700">
                                                {invoice.currencyType}
                                            </Text>
                                        </td>
                                        <td style={cellStyle('right')} className="whitespace-nowrap">
                                            <Text size="sm" weight={500} className="text-slate-700">
                                                {`${invoice.penaltyRate}%`}
                                            </Text>
                                        </td>
                                        <td style={cellStyle('left')} className="whitespace-nowrap">
                                            <Text size="sm" weight={500} className="text-slate-700">
                                                {`${invoice.creditPeriod} days`}
                                            </Text>
                                        </td>
                                        <td style={cellStyle('left')} className="whitespace-nowrap">
                                            <Text size="sm" weight={500} className="text-slate-700">
                                                {`${getAgeingDays(invoice.dueDate, invoice.creditPeriod)} days`}
                                            </Text>
                                        </td>
                                        <td style={cellStyle('center')} className="whitespace-nowrap">
                                            <div className="flex items-center justify-center gap-2">
                                                <ActionIcon
                                                    title="Open"
                                                    onClick={() => handleFileOpening(invoice)}
                                                    variant="subtle"
                                                >
                                                    <File size={18} />
                                                </ActionIcon>
                                                {Object.keys(invoiceData).length !== 0 && (
                                                    <ActionIcon
                                                        title="Disable"
                                                        onClick={() => handleInvoiceDisable(invoice)}
                                                        variant="subtle"
                                                    >
                                                        <Ban size={18} color="red" />
                                                    </ActionIcon>
                                                )}
                                                {/* <ActionIcon
                                                    title="Edit"
                                                    onClick={() => handleInvoiceEdit(invoice)}
                                                    variant="subtle"
                                                >
                                                    <Edit size={18} color="red" />
                                                </ActionIcon> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )}
        </>
    );
}

export default InvoiceListSection;